// extracted by mini-css-extract-plugin
export default {"loader":"SBcX7F","spin":"FhkMQV"};